import { Pipe, PipeTransform } from "@angular/core";
import {PkPluckProps} from "../../types";

@Pipe({name: 'pluck'})
export class PluckPipe implements PipeTransform {
  transform (input: any[], settings: PkPluckProps): any {
      return input.map(value => value[settings.keyToMap]);
  }
}
